var search = (function ($) {
  "use strict";

  var $langField;
  var $versionField;
  var $productField;
  var $keywordsField;
  var $searcResultsContainer;

  var pageLanguage = urlControl.getURLParameter("lang") || "en";
  var allProductJson = {};
  var lang = urlControl.getURLParameter("lang") || "en";
  var product = urlControl.getURLParameter("product") || "";
  var version = urlControl.getURLParameter("version") || "";
  var keywords = urlControl.getURLParameter("q")
    ? decodeURIComponent(urlControl.getURLParameter("q").replace(/\+/g, " "))
    : "";

  var urlLinkBuilder = (function ($) {
    var buildProductLink = function (category, path, language, version, id) {
      return (
        "product.html" +
        urlControl.getURLSymbol() +
        category +
        "/" +
        path +
        "/" +
        language +
        "/" +
        version +
        "/" +
        id
      );
    };

    var buildSearchHash = function (params, useParameterSymbol) {
      var paramsStr = $.param(params);
      paramsStr = decodeURIComponent(paramsStr);
      var currentUrl = window.location.href.split(/[\?\#]/)[0];
      var newHash = useParameterSymbol
        ? "?" + paramsStr
        : urlControl.getURLSymbol() + paramsStr;
      var link = currentUrl + newHash;
      return link;
    };

    return {
      buildProductLink: buildProductLink,
      buildSearchHash: buildSearchHash,
    };
  })(jQuery);

  var loadSupportedLanguages = function (combinedJson, selectedLang) {
    var pageLang = selectedLang || lang;
    var combineList = jsonUtility.getAllLanguages(combinedJson);
    var qkeyword = urlControl.getURLParameter("q");
    var menuItems = "";
    $.each(combineList, function (index, language) {
      var url =
        urlLinkBuilder.buildSearchHash({ lang: language.code }, true) +
        "#q=" +
        qkeyword;
      var selected = "";
      if (pageLang === language.code) {
        omni.languageMenus.setCurrentValue(
          omni.localizeLanguage(language.code, language.name)
        );
        selected = "class='selected'";
      }
      var addLang = pageLanguage !== language.code? "' lang='" + language.code : "";
      menuItems +=
        "<li " +
        selected +
        "><a href='" +
        url +
        addLang + 
        "' data-code='" +
        language.code +
        "'>" +
        omni.localizeLanguage(language.code, language.name) +
        "</a></li>";
    });

    var addHTMLLangAttrs = function (){
      if (document.querySelector("html").lang!==(pageLanguage||'en')){
        document.querySelector("html").lang=pageLanguage
      }   
    }
    
    addHTMLLangAttrs();
    omni.languageMenus.disableRefresh();
    omni.languageMenus.addMenuItems($(menuItems));
  };

  /****
   HELP-264
   Add Coveo support
  ****/

  var initCoveo = function (lang) {
    var startInit = (async () => {
      await customElements.whenDefined("atomic-search-interface");
      const searchInterface = document.querySelector("atomic-search-interface");
      const urlParams = new URLSearchParams(window.location.search);
      const languages = {
        "fr-ca": "fr-CA",
        "es-mx": "es-MX",
        "pt-br": "pt-BR",
        "zh-cn": "zh-CN",
        "zh-hk": "zh-HK",
        "zh-tw": "zh-TW",
      };
      var pagelang;
      var urllang = urlParams.get("lang");
      if (urllang) {
        if (urllang in languages) {
          pagelang = languages[urllang];
        } else {
          pagelang = urllang;
        }
      } else {
        pagelang = document.documentElement.lang;
      }

      await searchInterface.initialize({
        accessToken: "xx708d4099-27fa-4058-83ff-af143e73b4cf",
        organizationId: "fsecureproductionliellfha",
        organizationEndpoints: await searchInterface.getOrganizationEndpoints(
          "fsecureproductionliellfha"
        ),
      });
      searchInterface.executeFirstSearch();
      searchInterface.language = pagelang;

      function loadLanguage(lang) {
        var languagePath = "data/language-coveo/" + lang + ".json";
        var jsonCall = $.getJSON(languagePath, function () {
          var jsonData = JSON.parse(jsonCall.responseText);
          searchInterface.i18n.addResourceBundle(
            lang,
            "caption-source",
            jsonData[0]["caption-source"]
          );
          searchInterface.i18n.addResourceBundle(
            lang,
            "translation",
            jsonData[0]["translation"]
          );
        }).fail(function () {
          console.log("error - lang file not found");
        });
      }
      loadLanguage(pagelang);
      searchInterface.i18n.addResourceBundle(pagelang, "caption-language", {
        Bulgarian: "Български",
        Estonian: "Eesti",
        Danish: "Dansk",
        German: "Deutsch",
        Greek: "Ελληνικά",
        Spanish: "Español",
        "Spanish (LatAm)": "Español (LatAm)",
        Finnish: "Suomi",
        French: "Français",
        "French (CA)": "Français (CA)",
        Hungarian: "Magyar",
        Croatian: "Hrvatski",
        Czech: "Čeština",
        Italian: "Italiano",
        Japanese: "日本語",
        Korean: "한국어",
        Lithuanian: "Lietuvių",
        Dutch: "Nederlands",
        Norwegian: "Norsk",
        Polish: "Polski",
        Portuguese: "Português",
        "Portuguese (BR)": "Português (BR)",
        Romanian: "Română",
        Russian: "Русский",
        Slovenian: "Slovenščina",
        Serbian: "српски",
        Swedish: "Svenska",
        Thai: "ภาษาไทย",
        Turkish: "Türkçe",
        Vietnamese: "Tiếng Việt",
        "Chinese (Simplified)": "中文 (简体)",
        "Chinese (Hong Kong)": "中文 (香港)",
        "Chinese (Taiwan)": "中文 (繁體)",
      });
    })();

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        startInit();
      });
    }
  };

  //start here

  var init = function () {
    $langField = $("#langInput");
    $versionField = $("#versionInput");
    $productField = $("#productInput");
    $keywordsField = $(".magic-box-input input");
    $searcResultsContainer = $("#search-results");

    allProductJson = {};
    lang = urlControl.getURLParameter("lang") || "en";
    product = urlControl.getURLParameter("product") || "";
    version = urlControl.getURLParameter("version") || "";
    keywords = urlControl.getURLParameter("q")
      ? decodeURIComponent(urlControl.getURLParameter("q").replace(/\+/g, " "))
      : "";

    version = product !== "" ? version : "";
    navBar.setURLLang(lang);

    jsonUtility.loadProductListJsons(function (categoryJson) {
      allProductJson = categoryJson;
      loadSupportedLanguages(allProductJson);
      initCoveo(lang);
    });
  };

  init();

  return {
    reInit: init,
    urlLinkBuilder: urlLinkBuilder,
  };
})(jQuery);
